import React from "react";
import { StrongifierFeatures } from "../components/strongifier-features";
import { HeroBanner } from "../components/hero-banner";
import { PageLayout } from "../components/page-layout";

export const LandingPage: React.FC = () => (
  <PageLayout>
    <>
      <HeroBanner />
      <StrongifierFeatures />
    </>
  </PageLayout>
);
